import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { ModalHeader, ModalContents, ModalFooter } from '../../../common/modal'

import { withStyles } from 'material-ui/styles'
import styles from './styles'


class UploadCopperlimits extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      modal : false
    }
    this.state = {
      limitdbfile : null,
      errors : {

      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.uploadLimitDbFile = this.uploadLimitDbFile.bind(this)
  }
  handleChange(e) {
    let errors = {...this.state.errors}
    if(e.target.type=='file' && e.target.files.length){
      let fileExtention = e.target.files[0].name.split('.').pop();
      if(fileExtention === 'json'){
        this.setState({
          [e.target.name] : e.target.files[0],
          errors : {
            ...errors,
            [e.target.name] : false
          }
        })
      }else{
        this.setState({
          errors : {
            ...errors,
            [e.target.name] : true
          }
        })
      }
    }
  }
  uploadLimitDbFile(e) {
    e.preventDefault()
    let file = this.state.limitdbfile
    if(file){
      var fd = new FormData();
      fd.append('file', file)
      this.props.uploadLimitDb(fd)
      this.props.onClose()
    }
  }
  render(){
    const { classes, translate, onClose } = this.props
    const { limitdbfile, errors } = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_copper_limitsdb_title")}
              </Typography>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={errors.limitdbfile ? true : false}
                  >
                  <InputLabel htmlFor="limitdbfile" shrink={true} disableAnimation={true}>{translate("settings_copper_limitsdb_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="limitdbfile"
                      type="file"
                      name="limitdbfile"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"limitdbfile"
                      }}
                  />
                  <FormHelperText id="limitdbfile-helper-text">{translate("settings_copper_limitsdb_help")}</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>
            <ModalFooter>
              <Button raised
                onClick={onClose}
              >
                {translate('general_cancel')}
              </Button>
              {limitdbfile ? (<Button raised
                color="accent"
                type="submit"
                onClick={this.uploadLimitDbFile}
              >
                {translate("settings_upload")}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(UploadCopperlimits)
